import { adjustmentService, hubService, } from '@/services';
import HubAdjustmentVM from '@/view-model/hub-adjustment/HubAdjustmentVM';
import HubVM from '@/view-model/hub-management/HubVM';
import { EHubMainReportMutations, IHubMainReportActionTypes, } from './types';
const actions = {
    [IHubMainReportActionTypes.setFilterOption](context, payload = {}) {
        context.commit(EHubMainReportMutations.SET_FILTER_OPTION, payload);
    },
    async [IHubMainReportActionTypes.getSelectedHubInfo]({ commit, rootGetters }) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        if (!hubId) {
            return;
        }
        const { data } = await hubService.getSelectedHubInfo(hubId);
        commit(EHubMainReportMutations.GET_SELECTED_HUB_INFO, new HubVM(data));
    },
    async [IHubMainReportActionTypes.getHubMainReport]({ getters, commit, rootGetters, }) {
        try {
            const [fromAt, toAt,] = getters.getterSelectedMonthToFullDate;
            const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
            const param = {
                fromAt,
                toAt,
            };
            const { data } = await adjustmentService.getHubMainReport(hubId, param);
            commit('GET_HUB_MAIN_REPORT', new HubAdjustmentVM(data));
            return true;
        }
        catch (error) {
            console.log('[hubAdjustment/main/getHubMainReport]', error);
            const message = error.response?.data.error.message ?? error.message;
            commit('RESET_HUB_MAIN_REPORT');
            return {
                message,
            };
        }
    },
    [IHubMainReportActionTypes.resetHubMainReport](context) {
        context.commit(EHubMainReportMutations.RESET_HUB_MAIN_REPORT);
    },
};
export default actions;
